/**
 * Represents a service for getting the current space.
 */
export const GetCurrentSpaceService = Symbol('CurrentSpaceService');
/**
 * Represents a service for setting the current space.
 */
export const SetCurrentSpaceService = Symbol('SetCurrentSpaceService');
/**
 * Represents a service for managing the current space.
 */
export const CurrentSpaceService = Symbol('CurrentSpaceService');
